import { applyMiddleware, combineReducers } from "redux";
import createSagaMiddleware from "redux-saga";
import { all, fork, put } from "typed-redux-saga";
import { AppReducer, appActions, appSaga } from "./app";
import { AssetReducer, assetActions, assetSaga } from "./asset";
import { AuthReducer, authActions, authSaga } from "./auth";
import { ClientReducer, clientActions, clientSaga } from "./client";
import { DataReducer, dataActions, dataSaga } from "./data";
import { FileReducer, fileActions, fileSaga } from "./file";
import { GroupReducer, groupActions, groupSaga } from "./group";
import { SystemReducer, systemActions, systemSaga } from "./system";
import { UserReducer, userActions, userSaga } from "./user";

const sagaMiddleware = createSagaMiddleware({});
export function runSaga() {
  sagaMiddleware.run(function* () {
    yield all([
      fork(appSaga),
      fork(assetSaga),
      fork(authSaga),
      fork(clientSaga),
      fork(dataSaga),
      fork(fileSaga),
      fork(groupSaga),
      fork(userSaga),
      fork(systemSaga),
    ]);
  });
}
export const middlewares = applyMiddleware(sagaMiddleware);

export const reducers = combineReducers({
  app: AppReducer,
  asset: AssetReducer,
  auth: AuthReducer,
  client: ClientReducer,
  data: DataReducer,
  file: FileReducer,
  group: GroupReducer,
  user: UserReducer,
  system: SystemReducer,
});

export function* resetToInitialState() {
  yield* put(appActions.resetToInitialState());
  yield* put(assetActions.resetToInitialState());
  yield* put(authActions.resetToInitialState());
  yield* put(clientActions.resetToInitialState());
  yield* put(dataActions.resetToInitialState());
  yield* put(fileActions.resetToInitialState());
  yield* put(groupActions.resetToInitialState());
  yield* put(userActions.resetToInitialState());
  yield* put(systemActions.resetToInitialState());
}
